module.exports = __webpack_public_path__ + "src/images/products/active/21_Striped Slim Sweatpant in Salt and Pepper.png";